export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M8 21H2v-8h6v8Zm7 0H9v-8h6v8Zm7 0h-6v-8h6v8ZM3.5 19.5h3v-5h-3v5Zm7 0h3v-5h-3v5Zm7 0h3v-5h-3v5ZM8 12H2V4h6v8Zm7 0H9V4h6v8Zm7 0h-6V4h6v8ZM3.5 10.5h3v-5h-3v5Zm7 0h3v-5h-3v5Zm7 0h3v-5h-3v5Z"/>
</svg>
`;
